import { render, staticRenderFns } from "./Evolucao.vue?vue&type=template&id=4da70faf"
import script from "./Evolucao.vue?vue&type=script&lang=js"
export * from "./Evolucao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports